import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Row, Col, Checkbox } from 'antd';

import { tipusCampNoSuportat } from '../../constants';
import PopoverAlerta from '../commons/popoverAlerta';
import PopoverError from '../commons/popoverError';

import ObservacioIntroduccioVariableNumeric from './observacioIntroduccioVariableNumeric';
import ObservacioIntroduccioVariableLlista from './observacioIntroduccioVariableLlista';
import ObservacioIntroduccioVariableText from './observacioIntroduccioVariableText';
import ObservacioIntroduccioVariableHora from './observacioIntroduccioVariableHora';

import { observacioModificarValorFormulari, observacioIgnorarFiltresCoherenciaPerVariable } from '../../actions';

class ObservacioIntroduccioVariable extends Component {

    constructor(props) {
        super(props);
        this.renderVariable = this.renderVariable.bind(this);
        this.onChangeValorVariable = this.onChangeValorVariable.bind(this);
    }

    onChangeValorVariable(valor) {
        const { idVariable } = this.props.variable;
        this.props.observacioModificarValorFormulari(idVariable, (typeof(valor) !== 'undefined') ? valor : null);
    }

    renderPopoverErrorsCoherencia(variable) {
        const { errors, ignorarFiltresCoherencia } = variable;
        const PopoverErrorsCoherencia = ignorarFiltresCoherencia ? PopoverAlerta : PopoverError;

        const contingutPopover = (
            <div>
                { errors.map((error, index) => <p key={index}>{error}</p>) }
            </div>
        );

        return (
            <PopoverErrorsCoherencia
                titol='Error de coherència'
                contingut={contingutPopover}
                classNameIcona='observacio-introduccio-popover'
            />
        );
    }

    onChangeCheckBoxIgnorarFiltresCoherencia(idVariable, valorCheckbox) {
        this.props.observacioIgnorarFiltresCoherenciaPerVariable(idVariable, valorCheckbox);
    }

    renderCheckBoxIgnorarFiltresCoherenciaVariable(variable) {
        const { ignorarFiltresCoherencia } = variable;

        return (
            <Checkbox
                className='text-valor-variable-revisat'
                style={{marginLeft: '18px'}}
                defaultChecked={ignorarFiltresCoherencia}
                onChange={event => this.onChangeCheckBoxIgnorarFiltresCoherencia(variable.idVariable, event.target.checked)}>
                {'S\'ha revisat el valor'}
            </Checkbox>
        );
    }

    renderErrorVariable(variable) {
        const { errors } = variable;

        if (errors && errors.length > 0) {

            return <div className='observacio-introduccio-variable-error'>
                {this.renderPopoverErrorsCoherencia(variable)}
                {this.renderCheckBoxIgnorarFiltresCoherenciaVariable(variable)}
            </div>;
        }
    }

    renderVariable(variable) {
        switch (variable.tipus) {
            case 'Numeric':
                return (
                    <div>
                        <ObservacioIntroduccioVariableNumeric variable={variable} onChangeValorVariable={this.onChangeValorVariable} />
                        {this.renderErrorVariable(variable)}
                    </div>
                );
            case 'Llista':
                return (
                    <div>
                        <ObservacioIntroduccioVariableLlista variable={variable} onChangeValorVariable={this.onChangeValorVariable} />
                        {this.renderErrorVariable(variable)}
                    </div>
                );
            case 'Text':
                return (
                    <div>
                        <ObservacioIntroduccioVariableText variable={variable} onChangeValorVariable={this.onChangeValorVariable} />
                        {this.renderErrorVariable(variable)}
                    </div>
                );
            case 'Hora':
                return (
                    <div>
                        <ObservacioIntroduccioVariableHora variable={variable} onChangeValorVariable={this.onChangeValorVariable} />
                        {this.renderErrorVariable(variable)}
                    </div>
                );
            default:
                return <div>{tipusCampNoSuportat}</div>;
        }
    }

    render() {

        const variable = this.props.variable;

        return (
            <Row>
                <Col span={24}>{this.renderVariable(variable)}</Col>
            </Row>
        );
    }
}

ObservacioIntroduccioVariable.propTypes = {
    variable: PropTypes.object,
    observacioModificarValorFormulari: PropTypes.func,
    observacioIgnorarFiltresCoherenciaPerVariable: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        observacioModificarValorFormulari,
        observacioIgnorarFiltresCoherenciaPerVariable,
    }, dispatch);
};

export default connect(null, mapDispatchToProps)(ObservacioIntroduccioVariable);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioVariable.js